//共通
export const LOGIN = "/Login";
export const LOGOUT = "/Logout";
export const SSL_PAGE = "https://www.login.secomtrust.net/customer/customer/pfw/CertificationPage.do";
export const PASSPORT4WEB = "https://www.secomtrust.net/service/pfw/index.html";
export const STS_HP = "https://www.secomtrust.net/"

//ローカル開発環境
//export const API_PATH = "http://172.27.182.70:8080/WanMonitoringService";

// //検証環境
export const API_PATH = "https://nw-report-test.secomtrust.net/nl";

// //本番環境
//export const API_PATH = "https://nw-report.secomtrust.net/nl";

export const PAGE_TITLE_BASE ="レポート（拠点別グラフ）";
export const PAGE_TITLE_ITEM = "レポート（項目別グラフ）";